import { useLocation } from 'react-router'

const STEPS = [
	{ path: '/editor', label: 'Upload' },
	{ path: '/editor/edit', label: 'Edit' },
	{ path: '/editor/process', label: 'Process' },
	{ path: '/editor/export', label: 'Export' },
]

export function AudioStepIndicator() {
	const location = useLocation()
	const pathname = location.pathname

	// STEPS runs least- to most-specific; `/editor` is a path prefix of every
	// other step, so matching each step independently would light up both
	// "Upload" and the actual current step at once. Take the last (most
	// specific) match instead.
	const activeIndex = STEPS.reduce((match, step, i) => {
		const isMatch = pathname === step.path || pathname.startsWith(step.path + '/')
		return isMatch ? i : match
	}, -1)

	return (
		<div className="flex flex-wrap gap-2">
			{STEPS.map((step, i) => (
				<span
					key={step.path}
					className={
						i === activeIndex
							? 'font-semibold text-primary'
							: 'text-base-content/60'
					}
				>
					{i + 1}. {step.label}
					{i < STEPS.length - 1 ? ' → ' : ''}
				</span>
			))}
		</div>
	)
}
